import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { LegalMarkdownHelp } from '../LegalMarkdownHelp';
export function HelpGuideTab() {
    return (_jsx(LegalMarkdownHelp, {}));
}
